<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">Edit Match</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/playoffs" v-bind:exact="exact">Playoffs</v-breadcrumbs-item>
                        <v-breadcrumbs-item style disabled>Edit Match</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form">
                                <v-text-field label="Round" v-model="roundTitle" readonly></v-text-field>
                                <div class="mb-3">
                                    <team-badge
                                        v-bind:team="homeTeam.team"
                                        v-bind:colour="homeTeam.colour"
                                        v-bind:full_width="false"
                                    ></team-badge>&nbsp;vs.
                                    <team-badge
                                        v-bind:team="awayTeam.team"
                                        v-bind:colour="awayTeam.colour"
                                        v-bind:full_width="false"
                                    ></team-badge>
                                </div>
                                <v-text-field label="Game" v-model="gameTitle" readonly></v-text-field>
                                <v-text-field
                                    v-bind:label="`Away Score (${awayTeam.team})`"
                                    v-model="awayTeamScore"
                                    mask="###"
                                ></v-text-field>
                                <v-text-field
                                    v-bind:label="`Home Score (${homeTeam.team})`"
                                    v-model="homeTeamScore"
                                    mask="###"
                                ></v-text-field>
                                <v-date-picker
                                    v-model="datePicker"
                                    color="grey darken-2"
                                    reactive="reactive"
                                    class="mb-4"
                                    full-width
                                ></v-date-picker>
                                <v-time-picker
                                    v-model="timePicker"
                                    color="grey darken-2"
                                    class="mb-4"
                                    full-width
                                ></v-time-picker>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Update Match</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'AdminPlayoffsMatchEdit',
    props: ['match'],
    data() {
        return {
            exact: true,
            roundTitle: '',
            gameTitle: '',
            awayTeam: '',
            awayTeamScore: -1,
            homeTeam: '',
            homeTeamScore: -1,
            datePicker: '',
            timePicker: ''
        }
    },
    mounted() {
        this.roundTitle = this.$store.getters.getPlayoffRoundById(this.match.round_id).round_title
        this.gameTitle = this.match.match_title
        this.awayTeamId = this.match.away_team_id
        this.awayTeamScore = this.match.away_team_score
        this.homeTeamId = this.match.home_team_id
        this.homeTeamScore = this.match.home_team_score
        if (this.match.match_moment) {
            this.datePicker = this.match.match_moment.format('YYYY-MM-DD')
        }

        if (this.match.match_moment) {
            this.timePicker = this.match.match_moment.format('HH:mm')
        }

        this.awayTeam = this.$store.getters.getTeamById(this.match.away_team_id)
        this.homeTeam = this.$store.getters.getTeamById(this.match.home_team_id)
    },
    methods: {
        getTeam(team_id) {
            let team = this.$store.getters.getTeamById(team_id)
            if (team) {
                return team
            }
        },
        submit() {
            if (!this.awayTeamScore) {
                this.awayTeamScore = -1
            }

            if (!this.homeTeamScore) {
                this.homeTeamScore = -1
            }

            let matchDate = null
            if (this.datePicker && this.timePicker) {
                let matchMoment = this.$moment(`${this.datePicker} ${this.timePicker}`)
                if (this.$moment.isMoment(matchMoment)) {
                    matchDate = matchMoment.toDate()
                }
            }

            this.$store.dispatch('updatePlayoffMatch', {
                id: this.match.id,
                away_team_score: parseInt(this.awayTeamScore),
                home_team_score: parseInt(this.homeTeamScore),
                match_datetime: matchDate
            })
        }
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
